"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _TagNumber = _interopRequireDefault(require("@rsuite/icon-font/lib/application/TagNumber"));

// Generated by script, don't edit it please.
var TagNumber = (0, _createSvgIcon["default"])({
  as: _TagNumber["default"],
  ariaLabel: 'tag number',
  category: 'application',
  displayName: 'TagNumber'
});
var _default = TagNumber;
exports["default"] = _default;
module.exports = exports.default;